import { Grid, Typography } from '@material-ui/core';
import { rippleStyles } from '@ncr-retail/base-retail-components';
import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { PageStatus, setHomePage } from 'src/common/components/emerald-home-page/emerald-home-page';
import { POSModeState } from 'src/common/interfaces/states/POSModeState';
import { AppState } from 'src/common/redux/configure-store';
import { trainingModeStyles } from 'src/common/training-mode/training-mode-styles';
import TrainingModeWatermark from 'src/common/training-mode/training-mode-watermark';
import { ScannedDataHandler } from 'src/devices/scanner-operations';
import BaseButton from '../../common/components/base-button';
import Barcode from '../../common/media/barcode-h.svg';
import SalesKeypad from '../../sales-keypad/components/sales-keypad';
import { returnItemStyles } from './return-item-styles';
import { getIsManualWeightDisabledForReturnItem } from 'src/common/device/scale/scale-helper';

export const showReturnItemPage = (
  props: IReturnItemProps,
  scanHandler: ScannedDataHandler,
): void => {
  const pageStatus: PageStatus = {
    enablePluMenu: true,
    enableSearch: true,
  };
  setHomePage(<ReturnItem {...props} />, scanHandler, pageStatus);
};

const ReturnItem: React.FC<IReturnItemProps> = (props: IReturnItemProps): JSX.Element => {
  const classes = returnItemStyles();
  const ripple = rippleStyles();
  const { t } = useTranslation();
  const trainingModeClasses = trainingModeStyles();
  const leftHanded = useSelector((state: AppState): boolean => state.cashierPreferences.leftHanded);
  const posModeState = useSelector((state: AppState): POSModeState => state.posMode);
  // Check to see if the scale is in use.  If so, user can't enter manual weight
  const scaleActive = useSelector((state: AppState) => state.scale);
  return (
    <Grid
      item
      className={`fullHeight flexFull ${classes.outerMostContainer}`}
      data-testid='return-Item'
    >
      <Grid
        item
        className={`${
          posModeState.trainingMode
            ? trainingModeClasses.trainingModeBackground
            : classes.background
        } fullWidth fullHeight`}
      >
        {posModeState.trainingMode && (
          <TrainingModeWatermark supplementalStyles={trainingModeClasses.centerTradeWaterMark} />
        )}
        <Grid
          container
          direction='column'
          className={`fullHeight ${classes.returnItemContainer} ${classes.outerFlexDesgin}`}
          data-testid='return-Item-container'
        >
          <Grid
            container
            direction='column'
            justifyContent='center'
            className={`${classes.returnItemTitleContainer} fullWidth`}
            data-testid='return-Item-title'
          >
            <Grid item className={classes.fitHeight}>
              <Grid
                container
                direction='column'
                className={`${classes.returnItemTitleContainer} fullWidth`}
              >
                <Typography
                  variant='h2'
                  className={classes.returnItemTitleHeader}
                  data-testid='return-Item-title-text'
                >
                  {t('ItemReturning')}
                </Typography>
                <Grid item xs={1}>
                  <Typography className={`${classes.returnItemTitleBar}`} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            container
            className={classes.flexDesign}
            direction={leftHanded ? 'row-reverse' : 'row'}
          >
            <Grid item container xs={9}>
              <Grid item container className={classes.containerAlignment}>
                <Typography
                  className={classes.returnItemTitleHeader}
                  data-testid='return-Item-body-text'
                >
                  {t('Empty_Cart_Return_Mode')}
                </Typography>
                <Grid container justifyContent='center'>
                  <img src={Barcode} className={classes.icon} alt='' />
                </Grid>
              </Grid>
              <Grid item container justifyContent='center' className={classes.selfAlign}>
                <BaseButton
                  variant='contained'
                  className={`${ripple.textButton} ${classes.buttonStyles}`}
                  centerRipple
                  onClick={props.onCancel}
                  data-testid='return-Item-cancel-button'
                >
                  {t('CancelLoyalty')}
                </BaseButton>
                <BaseButton
                  variant='contained'
                  className={classes.searchButtonStyles}
                  centerRipple
                  onClick={props.onSearch}
                  data-testid='return-Item-search-button'
                >
                  {t('Search')}
                </BaseButton>
              </Grid>
            </Grid>
            <Grid item className={classes.keypadContainer}>
              <SalesKeypad
                keyboardId={'return-item'}
                topLabelText={t('Keypad_Label_Return_Mode')}
                isKeypadVisible={true}
                dataTestIdModifier={'return-Item'}
                keyPadSubmit={props.onKeypadSumbit}
                disableManualWeight={getIsManualWeightDisabledForReturnItem(scaleActive)}
                disableQuantity={false}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ReturnItem;

export interface IReturnItemProps {
  onCancel: () => void;
  onKeypadSumbit: (input: string) => void;
  onSearch: () => void;
}
